import { CustomSeriesOptions, customSeriesDefaultOptions } from "lightweight-charts";

export interface VolumeCandleSeriesOptions extends CustomSeriesOptions {
    color: string;
    upColor: string;
    downColor: string;
    borderUpColor: string;
    borderDownColor: string;
    wickUpColor: string;
    wickDownColor: string;
}

export const defaultVolumeCandleOptions: VolumeCandleSeriesOptions = {
    ...customSeriesDefaultOptions,
    color: '#000000',
    upColor: '#26a69a',
    downColor: '#ef5350',
    borderUpColor: '#26a69a',
    borderDownColor: '#ef5350',
    wickUpColor: '#26a69a',
    wickDownColor: '#ef5350',
}
